import { render, staticRenderFns } from "./SearchByKeywords.vue?vue&type=template&id=474d2c15&"
import script from "./SearchByKeywords.vue?vue&type=script&lang=js&"
export * from "./SearchByKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports